<template>
  <div class="send" :style="{minHeight:minHeight+'px'}" @click="hidedraft()">
    <!-- <router-view/> -->
    <headerCom>
        <div class="flex-lm" style="opacity: .8;">
          <div class="work-acts flex-lm white-font font-size14">
              <div class="flex-cm work-act-single white-font font-size14">
                <div class="bg-green botton-content flex-cm only-click-button">
                  <img src="https://assets.pfotoo.com/win-notice.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                  <span>发送领奖通知</span>
                </div>
              </div>
              <div class="flex-cm work-act-single white-font font-size14">
                <div class="bg-green botton-content flex-cm only-click-button">
                  <img src="https://assets.pfotoo.com/send-notice.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                  <span>发送结果通知</span>
                </div>
              </div>
              <div class="flex-cm work-act-single white-font font-size14">
                <div class="bg-green botton-content flex-cm only-click-button">
                  <img src="https://qn002.pfotoo.com/tick-notice.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                  <span>发送投票通知</span>
                </div>
              </div>
              <div class="flex-cm work-act-single white-font font-size14">
                <div class="bg-green botton-content flex-cm only-click-button">
                  <img src="https://assets.pfotoo.com/define-notice.svg" style="width: 14px;height: 14px;margin-right: 5px;"/>
                  <span>自定义通知</span>
                </div>
              </div>
          </div>
        </div>
    </headerCom>
    <div class="send-content bg-white" :style="{minHeight:minHeight+'px'}">
      <draftcover ref="collectcover" v-on:getdraftid="getdraftid"></draftcover>
      <div class="flex-vc" :style="{minHeight:minHeight-45+'px'}">
        <img src="https://assets.pfotoo.com/pc/img/jd-1.png" class="send-image"/>
        <div class="flex-lm font-size16 gray-font">在京东挑选奖品，我们将可能获得京东的推广费用，来持续改进Fotoo小程序</div>
        <a href="https://union-click.jd.com/jdc?e=&p=JF8AAJwDIgZlGmsUMlZYDUUEJVtXQhRZUAscVEETBABAHUBZCSsvVXdidRZOWHcGYFwQaAh3aXZkAhI7GQ4iAlUaWhYLGwVQGWsVAxMEUxlbFgEVN2UbWiVJfAZlGVoUABAPUR1fEDISAFYeWBQCGwFVG18SMhUHXCssS0dMWYGU682opdDuv42MjCI3ZRhrJTISB2Uba0pGT1plGVoUBhs" target="_blank">
          <img src="https://assets.pfotoo.com/pc/img/创建通知 copy备份.svg" class="concat-button-jd"/>
        </a>
      </div>
    </div>
  </div>

</template>

<script>
  import headerCom from '../header.vue'
  import draftcover from '../draftcover.vue'
  export default {
      name: 'send',
      data () {
        return {
          minHeight:window.innerHeight-82,
          openid:JSON.parse(localStorage.getItem('userinfo')).openid,
          userinfo:JSON.parse(localStorage.getItem('userinfo')),
        }
      },
      components:{
        headerCom,
        draftcover,
      },
    methods:{
      getsign(){
          return this.$getsign();
       },
       getdetail(){
        this.$http({
          url:'https://pfotoo.com?s=App.Contribution.GetContributionById'+this.$getsign(),
          params:{
            id:this.id,
            openid:this.openid
          },
          method:'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          console.log(res.body)
          let json=res.body;
          if(res.body.ret==200){
             console.log(json)
             this.draftinfo=json.data.contribution[0];
          }
        })
      },
      getdraftid(obj){
        console.log(obj)
        this.id=obj.id;
        this.hidedraft();
        // this.getdetail();
      },
      hidedraft(){
        console.log('rrrrrrrr')
        this.$refs.collectcover.closedraft();
      },
    },
    mounted(){

    },

  }
</script>

<style>
  .send-image{
    width: calc(888px * 0.5);
    height: calc(506px * 0.5);
    margin-bottom: 70px;
  }
  .concat-button-jd{
    width: 152px;
    height: 42px;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/list/jd.vue